import { render, staticRenderFns } from "./HomeMarket.vue?vue&type=template&id=80c3c6f8&scoped=true"
import script from "./HomeMarket.vue?vue&type=script&lang=js"
export * from "./HomeMarket.vue?vue&type=script&lang=js"
import style0 from "./HomeMarket.vue?vue&type=style&index=0&id=80c3c6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c3c6f8",
  null
  
)

export default component.exports